<template>
  <div id="container">
    <div class="search-style">
      <el-form :model="queryParams">
        <el-row :gutter="10">
          <el-col :span="14">
            <el-col :span="6">
              <el-form-item>
<!--                <el-input v-model="queryParams.noticeTypeTitle" clearable placeholder="请输入标题"></el-input>-->
                <el-select v-model="queryParams.expressionex">
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                    v-for="(item,index) in expressionListex"
                    :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-date-picker
                  v-model="queryParams.createDate"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00','23:59:59']"
                  style="width:100%"
                  v-if="queryParams.expressionex === 'createDate'"
                >
                </el-date-picker>
                <el-select v-model="queryParams.flag" v-else-if="queryParams.expressionex === 'flag'">
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                    v-for="(item,index) in flagselect"
                    :key="index"
                  ></el-option>
                </el-select>
                <el-input v-else v-model="queryParams.value" clearable placeholder="请输入关键词"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-button type="primary" @click="onSearch">搜索</el-button>
                <el-button @click="resetForm()">重置</el-button>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="10" style="text-align:right;">
            <el-button @click="addNotice" type="primary">发布</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="box-table"  :style="{height:tableHeight + 'px'}">
      <div  :style="{height:tableHeight-40 + 'px'}">
        <el-table
          ref="custromTableRef"
          :data="tableData"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          :max-height="tableHeight-40"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
          border
        >
          <el-table-column prop="noticeTypeTitle" label="公告标题">
            <template slot-scope="scope">
              <b :class="{'red':scope.row.noticeTypeTitle.substring(1,3) === '重要'}">【{{scope.row.noticeTypeTitle.substring(1,3)}}】</b>
              {{scope.row.noticeTypeTitle.substring(4)}}
            </template>
          </el-table-column>
          <el-table-column prop="createUser" label="发送人"></el-table-column>
          <el-table-column prop="flag" label="状态">
            <template slot-scope="scope">
              <div class="status open" v-if="scope.row.flag === 1"><span></span>开启</div>
              <div class="status close" v-else><span></span>关闭</div>
            </template>
          </el-table-column>
          <el-table-column prop="createDate" label="时间"></el-table-column>
          <el-table-column prop="" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="editNotice(scope.row.snId)">编辑</el-button>
              <el-button type="text" v-if="scope.row.flag === 1" @click="systemNotice(scope.row.snId,false)">关闭</el-button>
              <el-button type="text" v-else @click="systemNotice(scope.row.snId,true)">开启</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagination :query.sync="query" @refresh="getNoticeAdministrationList" style="padding-top: 10px;"></Pagination>
    </div>
    <base-dialog
      :dialog-visible.sync="dialogVisibleex"
      @successEv="successSystem"
    >
      <div style="padding:0 30px 20px;">{{dialogtxt}}</div>
    </base-dialog>
  </div>
</template>

<script>
import noticeApi from '@/api/workbench/notice'
import Pagination from '@/components/module/Pagination'
import baseDialog from '@/components/module/baseDialog'
import { expressionList } from '@/components/utils/data'
import { confirm, isSuccess } from '@/util/tool'
import { creatBasePageData } from '@/util/date'
import { parseTime } from '@/util'

export default {
  name: 'noticeAdmininstration',
  data () {
    return {
      tableHeight: window.innerHeight - 270,
      dialogVisibleex: false,
      isopen: false,
      systemSnid: '',
      queryParams: {
        expressionex: 'noticeTypeTitle',
        value: '',
        createDate: [],
        flag: '1'
      },
      flagselect: [{
        label: '开启',
        value: '1'
      }, {
        label: '关闭',
        value: '0'
      }],
      expressionListex: [{
        label: '公告标题',
        value: 'noticeTypeTitle'
      }, {
        label: '发布时间',
        value: 'createDate'
      }, {
        label: '状态',
        value: 'flag'
      }, {
        label: '发送人',
        value: 'createUser'
      }],
      tableData: [],
      expressionList,
      loadingTable: false,
      query: { ...creatBasePageData() }
    }
  },
  computed: {
    dialogtxt () {
      return this.isopen ? '确定开启吗？' : '确认关闭吗？'
    }
  },
  components: { Pagination, baseDialog },
  mounted () {
    this.getNoticeAdministrationList()
  },
  methods: {
    systemNotice (snId, flag) {
      this.dialogVisibleex = true
      this.isopen = flag
      this.systemSnid = snId
    },
    successSystem () {
      this.isopen ? this.openNotice(this.systemSnid) : this.closeNotice(this.systemSnid)
    },
    editNotice (snId) {
      this.$router.push({
        name: 'noticeaddoredit',
        query: {
          snId
        }
      })
    },
    closeNotice (snId) {
      noticeApi.closeNotice({
        snId,
        flag: 0
      }).then(res => {
        if (isSuccess(res)) {
          this.getNoticeAdministrationList()
        }
      })
    },
    openNotice (snId) {
      noticeApi.closeNotice({
        snId,
        flag: 1
      }).then(res => {
        if (isSuccess(res)) {
          this.getNoticeAdministrationList()
        }
      })
    },
    addNotice () {
      this.$router.push({
        name: 'noticeaddoredit'
      })
    },
    onSearch () {
      const {
        queryParams
      } = this
      let value = queryParams.value
      if (queryParams.expressionex === 'createDate') {
        value = queryParams.createDate[0]
      }
      if (queryParams.expressionex === 'flag') {
        value = queryParams.flag
      }
      if (!value) {
        this.$message.error('请输入搜索条件')
        return
      }
      this.getNoticeAdministrationList()
    },
    getNoticeAdministrationList () {
      const { query, queryParams } = this
      let value = queryParams.value
      if (queryParams.expressionex === 'createDate') {
        value = queryParams.createDate[0]
      } else if (queryParams.expressionex === 'flag') {
        value = queryParams.flag
      }
      const params = {
        criteriaVoList: [{
          collection: true,
          column: queryParams.expressionex,
          endValue: queryParams.createDate[1] || '',
          expression: '',
          value,
          valueType: ''
        }],
        queryPageName: ''
      }
      noticeApi.noticeAdministrationList({
        ...query,
        ...params
      })
        .then(res => {
          if (isSuccess(res)) {
            const {
              current,
              size,
              total
            } = res.data.obj
            this.query = Object.assign({}, {
              page: current,
              size,
              total
            })
            this.tableData = res.data.obj.records.map(item => {
              item.createDate = parseTime(item.createDate)
              return item
            })
          }
        })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    resetForm () {
      this.queryParams = {
        expressionex: 'noticeTypeTitle',
        value: '',
        createDate: [],
        flag: '1'
      }
      this.getNoticeAdministrationList()
    }
  }
}
</script>

<style scoped>
  .status span {
    display: inline-block;
    width: 6px;
    height: 6px;
    vertical-align: 2px;
    border-radius: 50%;
    margin-right: 5px;
  }

  .status.open span {
    background: #276CFF;
  }

  .status.close span {
    background: #C1C5CD;
  }
  b.red{
    color: #D35E5E;
  }
</style>
